import { API } from '@utils'
//************************************//
export const _getAssignmentList = ({ limit, page, sort, filter, withSavedQueries }, callback) => {
  API.get('/assignment/list', {
    params: {
      limit,
      page,
      sort,
      filter,
      with_saved_queries: withSavedQueries
    }
  })
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (res) { })
}

//************************************//
export const _showAssignment = (id, callback, params = {}) => {
  const groupedAssignees = !_.isNil(params.groupedAssignees) ? params.groupedAssignees : false
  const fieldsAsObject = !_.isNil(params.fieldsAsObject) ? params.fieldsAsObject : false
  const withCustomFields = !_.isNil(params.withCustomFields) ? params.withCustomFields : false
  API.get(`/assignment/${id}`, {
    params: {
      grouped_assignees: groupedAssignees,
      fields_as_object: fieldsAsObject,
      with_custom_fields: withCustomFields
    }
  })
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (res) { })
}
//************************************//
export const _createAssignment = (data, callback, callbackError) => {
  API.post(`/assignment/new`, data)
    .then(function (res) {
      callback(res)
    })
    .catch(function ({ data }) {
      if (callbackError) callbackError(data?.data)
    })
}
export const _updateAssignment = (id, data, callback, callbackError) => {
  API.put(`/assignment/${id}`, data)
    .then(function (res) {
      callback(res)
    })
    .catch(function ({ data }) {
      if (callbackError) callbackError(data?.data)
    })
}
//************************************//
export const _deleteAssignment = (id, callback) => {
  API.delete(`/assignment/${id}`)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (res) { })
}
//************************************//
export const _pauseAssignment = (id, callback) => {
  API.post(`/assignment/${id}/pause`)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (res) { })
}
//************************************//
export const _resumeAssignment = (id, callback) => {
  API.post(`/assignment/${id}/active`)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (res) { })
}

export const _cloneAssingment = (id, data, callback) => {
  // console.log(data)
  API.post(`/assignment/${id}/clone`, data)
    .then(function (data) {
      callback(data)
    })
    .catch(function (res) { })
}
//************************************//
export const _searchUserGroup = async ({ q = '', ids = [] } = {}) => {
  return await API.get(`/user/search-user-group`, {
    params: {
      q,
      ids
    }
  })
    .catch(function (res) { })
}
//************************************//
export const _searchUserWithGroup = async (q = '') => {
  const usersRes = await API.get(`user/search`, {
    params: {
      limit: 20,
      q
    }
  })
  const users = _.map(usersRes.data, (v, k) => {
    return { value: v.id, label: v.full_name, type: 'user' }
  })

  const groupsRes = await API.get(`/user/group/all`)
  const groups = _.map(groupsRes.data, (v, k) => {
    return { value: v.id, label: v.name_lang, type: 'group' }
  })
  return [
    {
      label: 'Users',
      options: users
    },
    {
      label: 'Groups',
      options: groups
    }
  ]
}
//************************************//
export const _showAssignmentCustomFields = (callback) => {
  API.get(`/assignment/custom-fields`)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (res) { })
}
//************************************//
export const _showAssignmentSettingCustomFields = (callback) => {
  API.get(`/assignment/settings/custom-fields`)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (res) { })
}
//************************************//
export const _updateAssignmentSettingCustomFields = (data, callback) => {
  API.put(`/assignment/settings/custom-fields`, data)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (res) { })
}
//************************************//
export const _deleteAssignmentSettingUnusedCustomField = async (id, callback) => {
  const res = await API.delete(`/assignment/settings/custom-fields/unused-fields/${id}/delete`)
  return res.data
}
//************************************//